import { call } from '../@';

export type GetTransactionTaskMetadataPayload = {
	id: string;
	taskId: string;
};

export type TransactionTaskMetadata = {
	description?: string;
};

const getTransactionTaskMetadata = async (payload: GetTransactionTaskMetadataPayload) =>
	await call('transaction-getTaskMetadata', payload);

export default getTransactionTaskMetadata;
